var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBusiness(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_578_5059",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.199951,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_578_5059)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.80775 20.7C4.30258 20.7 3.875 20.525 3.525 20.175C3.175 19.825 3 19.3974 3 18.8922V8.5077C3 8.00253 3.175 7.57495 3.525 7.22495C3.875 6.87495 4.30258 6.69995 4.80775 6.69995H9V5.0077C9 4.50253 9.175 4.07495 9.525 3.72495C9.875 3.37495 10.3026 3.19995 10.8078 3.19995H14.1923C14.6974 3.19995 15.125 3.37495 15.475 3.72495C15.825 4.07495 16 4.50253 16 5.0077V6.69995H20.1923C20.6974 6.69995 21.125 6.87495 21.475 7.22495C21.825 7.57495 22 8.00253 22 8.5077V18.8922C22 19.3974 21.825 19.825 21.475 20.175C21.125 20.525 20.6974 20.7 20.1923 20.7H4.80775ZM10.5 6.69995H14.5V5.0077C14.5 4.9307 14.4679 4.8602 14.4038 4.7962C14.3398 4.73203 14.2692 4.69995 14.1923 4.69995H10.8078C10.7308 4.69995 10.6603 4.73203 10.5963 4.7962C10.5321 4.8602 10.5 4.9307 10.5 5.0077V6.69995ZM20.5 14.95H15V15.796C15 16.0538 14.9138 16.2689 14.7413 16.4412C14.5689 16.6137 14.3538 16.7 14.096 16.7H10.904C10.6462 16.7 10.4311 16.6137 10.2588 16.4412C10.0863 16.2689 10 16.0538 10 15.796V14.95H4.5V18.8922C4.5 18.9692 4.53208 19.0397 4.59625 19.1037C4.66025 19.1679 4.73075 19.2 4.80775 19.2H20.1923C20.2693 19.2 20.3398 19.1679 20.4038 19.1037C20.4679 19.0397 20.5 18.9692 20.5 18.8922V14.95ZM11.5 15.2H13.5V13.2H11.5V15.2ZM4.5 13.45H10V12.604C10 12.3461 10.0863 12.131 10.2588 11.9587C10.4311 11.7862 10.6462 11.7 10.904 11.7H14.096C14.3538 11.7 14.5689 11.7862 14.7413 11.9587C14.9138 12.131 15 12.3461 15 12.604V13.45H20.5V8.5077C20.5 8.4307 20.4679 8.3602 20.4038 8.2962C20.3398 8.23203 20.2693 8.19995 20.1923 8.19995H4.80775C4.73075 8.19995 4.66025 8.23203 4.59625 8.2962C4.53208 8.3602 4.5 8.4307 4.5 8.5077V13.45Z",
    fill: "#FAFAFA"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBusiness);
export default __webpack_public_path__ + "static/media/iconBusiness.4939cb10929614b55d4cd0d2eeaa2b83.svg";
export { ForwardRef as ReactComponent };